"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const generateReactApolloConfig = {
    plugins: [
        {
            add: {
                content: "/* eslint-disable */",
            },
        },
        "typescript",
        "typescript-operations",
        "fragment-matcher",
        "typescript-react-apollo",
    ],
    config: {
        gqlImport: "graphql-tag",
        skipTypename: true,
        withResultType: true,
        withMutationOptionsType: true,
        nameSuffix: "Type",
        operationResultSuffix: "OperationResult",
        avoidOptionals: false,
        maybeValue: "T | null",
        reactApolloVersion: 3,
    },
};
exports.default = generateReactApolloConfig;
//# sourceMappingURL=generate-react-apollo-config.js.map